// extracted by mini-css-extract-plugin
export var bannerTransform = "CookieBanner-module--banner-transform--UpTME";
export var button = "CookieBanner-module--button--zjlW7";
export var buttonDiv = "CookieBanner-module--buttonDiv--5ppEO";
export var container = "CookieBanner-module--container--vQHbQ";
export var cookieBannerMain = "CookieBanner-module--cookieBannerMain--RfjqN";